import React, { FC } from 'react';

import block from '../../utils/bem-cn-lite';
import type { IGrid } from './IGrid';
import { propTypes } from './IGrid';
import { propsToClassValues, propsWithoutGridValues } from './utils';

const cn = block('kitt-grid');

const Grid: FC<IGrid> = ({ tag = 'div', ...restProps }) => {
    const Tag = tag;
    const { children } = restProps;
    const classValues = propsToClassValues(restProps, propTypes);
    const classes = cn(classValues, restProps.className);

    const props = propsWithoutGridValues(restProps, propTypes);

    return (
        /* @ts-ignore */
        <Tag {...props} className={classes}>
            {children}
        </Tag>
    );
};

Grid.displayName = 'Grid';

export default Grid;
